import {
  defaultDropAnimationSideEffects,
  DragOverlay,
  DropAnimation,
} from "@dnd-kit/core"
import { Badge, Box } from "@mui/material"
import { PropsWithChildren } from "react"
import { OrderCard } from "src/app/components"
import { useAppSelector } from "src/app/hooks"
import { selectedOrderIdsSelector } from "src/app/slices/dashboard.slice"

const dropAnimationConfig: DropAnimation = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: "1",
        zIndex: "1",
      },
    },
  }),
}

export const SortableOverlay = ({ children }: PropsWithChildren<any>) => {
  return (
    <DragOverlay dropAnimation={dropAnimationConfig}>{children}</DragOverlay>
  )
}

export const OrderOverlay = () => {
  const activeDragItem = useAppSelector(
    (state) => state.dashboard.activeDragItem,
  )
  const selectedOrderIds = useAppSelector(selectedOrderIdsSelector)

  if (!activeDragItem) {
    return null
  }

  // Multi-drag: if the dragged item is part of selection and selection > 1
  const isMultiDrag =
    selectedOrderIds.includes(activeDragItem.id) && selectedOrderIds.length > 1
  const dragCount = isMultiDrag ? selectedOrderIds.length : 1

  return (
    <Box>
      <SortableOverlay>
        <Box sx={{ position: "relative" }}>
          {isMultiDrag && (
            <>
              {/* Stacked card shadows behind the main card */}
              <Box
                sx={(theme) => ({
                  position: "absolute",
                  top: 6,
                  left: 6,
                  right: -6,
                  bottom: -6,
                  borderRadius: 2,
                  border: `1px solid ${theme.palette.divider}`,
                  backgroundColor: theme.palette.background.paper,
                  zIndex: -1,
                })}
              />
              <Box
                sx={(theme) => ({
                  position: "absolute",
                  top: 3,
                  left: 3,
                  right: -3,
                  bottom: -3,
                  borderRadius: 2,
                  border: `1px solid ${theme.palette.divider}`,
                  backgroundColor: theme.palette.background.paper,
                  zIndex: -1,
                })}
              />
            </>
          )}
          <Badge
            badgeContent={dragCount > 1 ? dragCount : 0}
            color="primary"
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            sx={{
              display: "block",
              "& .MuiBadge-badge": {
                fontSize: "0.75rem",
                fontWeight: 700,
                minWidth: 24,
                height: 24,
                borderRadius: 12,
              },
            }}
          >
            <OrderCard showDivider={false} order={activeDragItem} />
          </Badge>
        </Box>
      </SortableOverlay>
    </Box>
  )
}
